import { always } from "ramda";
import { useSelector } from "react-redux";

import { selectRoutes } from "../components/formSettings.slice";
import { mapUrlToFormContextDataSelector } from "../router/utilities";

const getSelector = (route: string) =>
  mapUrlToFormContextDataSelector[route] || always(undefined);

export const useFormContext = ():
  | Record<
      string,
      | string
      | boolean
      | Record<string, unknown>
      | { label: string; value: string }[]
    >
  | undefined => {
  const { currentRoute } = useSelector(selectRoutes);
  const selector = getSelector(currentRoute);
  const formContext = useSelector(selector);

  return formContext;
};
